/**
 * App configuration.
 * This file is used to configure the app settings.
 * Below are the default values.
 */
export default defineAppConfig({
  siteName: 'OWNWEB',
  shortDescription: 'OWNWEB은 굿즈 쇼핑몰입니다.',
  description: `OWNWEB은 굿즈 쇼핑몰입니다.`,
  storeSettings: {},
});